import CashPickUp from '@/views/CashPickUp/index.vue'

const CashPickUpRouter = {
  path: '/cash-pickup',
  name: 'CashPickUp',
  component: CashPickUp,
  props: (route) => ({
    secret: route.query.secret,
    orderId: route.query.order_id
  })
}

export default CashPickUpRouter
